import { CustomerGroupMessage } from '../../../../types/CustomerGroupMessage';
import { queries } from '../../../common/api/queryKeys/queries';
import { usePaginationQuery } from '../../../common/hooks/usePaginationQuery';

export const useCustomerGroupsPagination = (searchQuery: string, page: number) => {
    const nextPage = queries.customerGroups.pagination({ searchQuery, page: page + 1 });

    return usePaginationQuery<CustomerGroupMessage>({
        ...queries.customerGroups.pagination({ searchQuery, page }),
        prefetchQueryKey: nextPage.queryKey,
        prefetchQueryFn: nextPage.queryFn,
    });
};
